function initAlphabetNavigation() {
  // Early exit: check if retailer cards exist on this page
  const retailerTitles = document.querySelectorAll('[class*="ai-retailer-cards-title"]');
  if (retailerTitles.length === 0) {
    return; // No retailer cards on this page, exit early
  }

  // Function to determine the first letter (skips "The ")
  function getFirstLetter(text) {
    if (!text) return '';
    const upperText = text.toUpperCase();
    if (upperText.startsWith('THE ')) {
      const words = text.split(' ');
      return words.length > 1 ? words[1].charAt(0).toUpperCase() : text.charAt(0).toUpperCase();
    }
    return text.charAt(0).toUpperCase();
  }
  
  // Create a map of letters -> first block
  const letterToBlockMap = new Map();
  retailerTitles.forEach(title => {
    const text = title.textContent.trim();
    const firstLetter = getFirstLetter(text);
    if (firstLetter && !letterToBlockMap.has(firstLetter)) {
      // Find the parent block (ai-retailer-cards container)
      const blockContainer = title.closest('[class*="ai-retailer-cards"]');
      if (blockContainer) {
        letterToBlockMap.set(firstLetter, blockContainer);
      }
    }
  });

  // Find the heading element that contains the alphabet navigation
  // Look for elements with ID starting with "shopify-block-heading" or any heading with alphabet navigation
  const headingSelectors = [
    '[id^="shopify-block-heading"]',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'p.h3', 'p[class*="heading"]'
  ];
  
  let alphabetHeading = null;
  
  for (const selector of headingSelectors) {
    const elements = document.querySelectorAll(selector);
    for (const heading of elements) {
      const text = heading.textContent.trim();
      // Check if it contains alphabet navigation (A B C D... or A  B  C  D...)
      // Look for text that contains only letters A-Z, Æ, Ø, Å and spaces, and has more than 20 characters
      if (text.match(/^[A-ZÆØÅ\s]+$/) && text.length > 20) {
        alphabetHeading = heading;
        break;
      }
    }
    if (alphabetHeading) break;
  }

  if (alphabetHeading && letterToBlockMap.size > 0) {
    // Create wrapper for clickable letters
    const text = alphabetHeading.textContent.trim();
    const letters = text.split(/\s+/).filter(l => l.length === 1 && /[A-ZÆØÅ]/.test(l));
    
    if (letters.length > 0) {
      // Create new HTML with clickable links
      const letterElements = letters.map(letter => {
        const hasBlock = letterToBlockMap.has(letter);
        if (hasBlock) {
          return `<a href="#" class="alphabet-nav-link" data-letter="${letter}" style="cursor: pointer; text-decoration: none; color: inherit; transition: opacity 0.2s;" onmouseover="this.style.opacity='0.7'" onmouseout="this.style.opacity='1'">${letter}</a>`;
        } else {
          return `<span style="opacity: 0.3; cursor: not-allowed;">${letter}</span>`;
        }
      }).join('  ');
      
      alphabetHeading.innerHTML = letterElements;
      
      // Add event listeners to links
      const links = alphabetHeading.querySelectorAll('.alphabet-nav-link');
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const letter = link.dataset.letter;
          const targetBlock = letterToBlockMap.get(letter);
          if (targetBlock) {
            targetBlock.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      });
    }
  }
}

function setupAlphabetNavigation() {
  initAlphabetNavigation();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupAlphabetNavigation);
} else {
  setupAlphabetNavigation();
}
